<template>
    <v-app v-if="isPublic !== null">

      <Navbar></Navbar>

      <v-content>
        <router-view v-if="isPublic"/>
        <Login v-else></Login>
      </v-content>

      <Footer v-if="$route.name !== 'result'"></Footer>

      <Notification/>
    </v-app>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import Notification from './components/Notification';
  import Footer from './components/Footer';
  import Navbar from './components/Navbar';
  import Login from './components/Login';

  export default {
    computed: {
      ...mapState([
        'isPublic'
      ])
    },
    components: {
      Navbar,
      Footer,
      Notification,
      Login
    },
    async created() {
      try {
        await this.login();
      } catch (e) {
        console.warn('Site is not public')
      }
    },
    methods: {
      ...mapActions([ 'login' ])
    }
  }
</script>
